import { render, staticRenderFns } from "./Assets.vue?vue&type=template&id=6e54dba2&scoped=true"
import script from "./Assets.vue?vue&type=script&lang=ts"
export * from "./Assets.vue?vue&type=script&lang=ts"
import style0 from "./Assets.vue?vue&type=style&index=0&id=6e54dba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e54dba2",
  null
  
)

export default component.exports